import ActiveRecord from './active_record/base'

class Skill extends ActiveRecord {
	static tableName = 'skills'
}

export default Skill
